<template>
  <v-chip small :color="COLORS_BY_ENTITY[entityType]" class="chip">
    <EntityIcon :entityType="entityType" class="me-1" />
    <p class="caption pa-0 ma-0" :class="TEXT_COLORS_BY_ENTITY[entityType]">
      {{ entityName }}
    </p>
  </v-chip>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

import EntityIcon from './EntityIcon.vue'

const COLORS_BY_ENTITY = {
  improvementIdea: 'blue lighten-2',
  problemSolving: 'red lighten-2',
  quickAction: 'orange lighten-2',
  routine: 'teal lighten-2',
  finding: 'blue-grey lighten-3',
  challenge: 'purple lighten-2',
  task: 'green lighten-2',
}

const TEXT_COLORS_BY_ENTITY = {
  improvementIdea: 'blue--text text--darken-2',
  problemSolving: 'red--text text--darken-2',
  quickAction: 'orange--text text--darken-2',
  routine: 'teal--text text--darken-2',
  finding: 'blue-grey--text text--darken-3',
  challenge: 'purple--text text--darken-2',
}

export default {
  name: 'EntityChip',

  components: {
    EntityIcon,
  },

  props: {
    entityType: {
      type: String,
      required: true,
      validator: val => Boolean(COLORS_BY_ENTITY[val]),
    },
  },

  data() {
    return {
      COLORS_BY_ENTITY,
      TEXT_COLORS_BY_ENTITY,
    }
  },

  computed: {
    ...mapGetters(['organization']),

    entityName() {
      switch (this.entityType) {
        case 'routine':
          return this.$t('routines.routine_one')
        case 'finding':
          return this.$t('routines.finding_one')
        case 'challenge':
          return this.$t('common.challenge_one')
        case 'task':
          return this.$t('common.task_one')
        default:
          return (
            this.organization?.customNamings?.[this.entityType]?.singular ||
            this.$t(`common.rev_type.${_.snakeCase(this.entityType)}_one`) ||
            ''
          )
      }
    },
  },
}
</script>
<style lang="scss">
.chip:before {
  background-color: inherit !important;
}
</style>
